import VerticalMenuTooltip from './VerticalMenuTooltip';

export default VerticalMenuTooltip;
